import axios from '@/plugins/axios';
import { queryClient } from '@/plugins/vueQuery';

export const experimentKey = (id) => ['experiment', id];
export const foldersKey = () => ['folders'];

export async function fetchExperimentCached(experimentId) {
    return queryClient.fetchQuery({
        queryKey: experimentKey(experimentId),
        queryFn: async () => {
            const response = await axios.get(`/experiments/${experimentId}`);
            return response.data;
        },
    });
}

export async function fetchFoldersCached() {
    return queryClient.fetchQuery({
        queryKey: foldersKey(),
        queryFn: async () => {
            const response = await axios.get('/folders');
            return response.data;
        },
    });
}

export function invalidateExperiment(experimentId) {
    // refetchType: 'none' marks the cache stale without triggering active refetches
    // from any mounted useQuery subscribers. The caller will fire an explicit
    // fetchExperimentCached right after, and we don't want double-fetches in the future
    // if/when a useQuery consumer is added.
    return queryClient.invalidateQueries({ queryKey: experimentKey(experimentId), refetchType: 'none' });
}

export function setExperimentCache(experimentId, data) {
    queryClient.setQueryData(experimentKey(experimentId), data);
}

export function getExperimentCache(experimentId) {
    return queryClient.getQueryData(experimentKey(experimentId));
}

export function invalidateFolders() {
    return queryClient.invalidateQueries({ queryKey: foldersKey(), refetchType: 'none' });
}
